import { Head, Link, useForm } from '@inertiajs/react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { AppLayout } from '@/layouts/AppLayout'
import { newUserSessionPath, userPasswordPath } from '@/lib/routes'

function ForgotPassword() {
  const form = useForm({ email: '' })

  return (
    <>
      <Head title="Reset password" />
      <div className="mx-auto flex min-h-[calc(100vh-4rem)] max-w-md items-center px-4 py-10">
        <Card className="w-full">
          <CardHeader className="space-y-1">
            <CardTitle className="text-2xl">Reset your password</CardTitle>
            <CardDescription>
              We&apos;ll email you a link to choose a new one.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form
              className="space-y-4"
              onSubmit={(event) => {
                event.preventDefault()
                form.transform((data) => ({ user: data }))
                form.post(userPasswordPath())
              }}
            >
              <div className="space-y-1.5">
                <Label htmlFor="email">Email</Label>
                <Input
                  autoComplete="email"
                  autoFocus
                  id="email"
                  inputMode="email"
                  onChange={(event) => form.setData('email', event.target.value)}
                  type="email"
                  value={form.data.email}
                />
                {form.errors.email && (
                  <p className="text-xs text-destructive">{form.errors.email}</p>
                )}
              </div>

              <Button className="w-full" disabled={form.processing} type="submit">
                {form.processing ? 'Sending…' : 'Send reset link'}
              </Button>

              <p className="text-center text-xs text-muted-foreground">
                Remembered it?{' '}
                <Link className="underline-offset-4 hover:text-foreground hover:underline" href={newUserSessionPath()}>
                  Sign in
                </Link>
              </p>
            </form>
          </CardContent>
        </Card>
      </div>
    </>
  )
}

export default Object.assign(ForgotPassword, {
  layout: (page: ReactNode) => <AppLayout>{page}</AppLayout>,
})
